import React from 'react';
import Icon from '../../../components/AppIcon';

const OfficialPartners = () => {
  const stats = [
    {
      icon: 'Building2',
      value: '50+',
      label: 'Partner Cities',
      color: '#14B8A6'
    },
    {
      icon: 'Hotel',
      value: '200+',
      label: 'Verified Hotels',
      color: '#14B8A6'
    },
    {
      icon: 'Users',
      value: '500+',
      label: 'Local Businesses',
      color: '#14B8A6'
    },
    {
      icon: 'Award',
      value: '10K+',
      label: 'Jobs Created',
      color: '#14B8A6'
    }
  ];

  return (
    <section className="w-full bg-[#1E293B] py-4 md:py-8">
      <div className="max-w-[1400px] mx-auto px-3 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-3 md:mb-6">
          <div className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-yellow-500/20 rounded-full mb-1.5 md:mb-3">
            <Icon name="Star" size={10} color="#EAB308" />
            <span className="text-yellow-400 font-semibold md:text-sm text-xs">
              Official Partners
            </span>
          </div>
          <h2 className="text-base md:text-2xl font-bold text-white mb-1.5">
            Trusted by Government & Industry Leaders
          </h2>
          <p className="text-[9px] md:text-sm text-gray-300 max-w-3xl mx-auto">
            We collaborate with local and national government units, tourism boards, and verified
            businesses to ensure safe, authentic, and memorable travel experiences.
          </p>
        </div>

        {/* Statistics Grid - 4 columns */}
        <div className="grid grid-cols-4 gap-1.5 md:gap-4">
          {stats?.map((stat, index) => (
            <div
              key={index}
              className="bg-[#2D3748] rounded-xl p-2 md:p-4 text-center hover:bg-[#374151] transition-all duration-300 border border-gray-700/50 hover:border-teal-500/50 group"
            >
              <div className="w-7 h-7 md:w-12 md:h-12 rounded-full bg-teal-500/10 flex items-center justify-center mx-auto mb-1 md:mb-2 group-hover:bg-teal-500/20 transition-all duration-300">
                <Icon name={stat?.icon} size={14} color={stat?.color} />
              </div>
              <div className="text-base md:text-2xl font-bold text-white mb-0.5">
                {stat?.value}
              </div>
              <div className="text-[8px] md:text-sm text-gray-400 font-medium break-words">
                {stat?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfficialPartners;